//Error messages definition for customer

export const 
    UNSELECTED_CUSTOMER_TYPE = "Należy wybrać typ klienta!",
    UNSELECTED_COMPANY = "Wybrany typ klienta wymaga określenia firmy!",
    EMPTY_CUSTOMER_NAME = "Pole osoba kontaktowa nie może być puste!",
    EMPTY_CUSTOMER_SURNAME = "Nazwisko nie może być puste!",
    EMPTY_CUSTOMER_EMAIL = "Pole email nie może być puste!",
    INCORRECT_EMAIL_FORMAT = "Wprowadzony adres email posiada niewłaściwy format!",
    EMPTY_CUSTOMER_CITY = "Pole miasto nie może być puste!",
    EMPTY_CUSTOMER_COUNTRY = "Pole państwo nie może być puste!",
    EMPTY_CUSTOMER_PHONE = "Pole telefon nie może być puste!",
    EMPTY_CUSTOMER_PHONE_CODE = "Pole numer kierunkowy nie może być puste!",
    INCORRECT_PHONE_CODE = "Numer kierunkowy ma niepoprawny format",
    INCORRECT_PHONE_FORMAT = "Wprowadzony telefon posiada niewłaściwy format!",
    INCORRECT_PHONE_MIN_LENGTH = "Pole telefon musi posiadać przynajmniej 5 znaków!",
    INCORRECT_PHONE_MAX_LENGTH = "Pole telefon może posiadać maksymalnie 20 znaków!",
    INCORRECT_COMPANY_TAXID_MAX_LENGTH = "Nip wybranej firmy może posiadać maksymalnie 13 znaków!",
    INCORRECT_CUSTOMER_NAME_MAX_LENGTH = "Pole osoba kontaktowa może posiadać maksymalnie 500 znaków!",
    INCORRECT_CUSTOMER_EMAIL_MAX_LENGTH = "Pole email może posiadać maksymalnie 40 znaków!",
    INCORRECT_CUSTOMER_CITY_MAX_LENGTH = "Pole miasto może posiadać maksymalnie 40 znaków!",
    INCORRECT_CUSTOMER_COUNTRY_MAX_LENGTH = "Pole państwo może posiadać maksymalnie 40 znaków!",
    EMPTY_CUSTOMER_POSTAL_CODE = "Pole kod pocztowy nie może być puste!",
    INCORRECT_POSTAL_CODE_FORMAT = "Wprowadzony kod pocztowy posiada niewłaściwy format (XX-XXX)!",
    EMPTY_CUSTOMER_STREET = "Pole ulica nie może być puste!",
    INCORRECT_CUSTOMER_STREET_MAX_LENGTH = "Pole ulica może posiadać maksymalnie 40 znaków!";



// WEBPACK FOOTER //
// ./src/const/ErrorMessages/CustomerErrorMessages.js